import * as React from "react";
import { Context } from "./_context";
export const NavigationShoppingAfterpayIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.5 1.5A2.5 2.5 0 0 1 17 4v2.5h3a1.5 1.5 0 0 1 1.462 1.163l2.434 10.55a3.5 3.5 0 0 1-3.41 4.287H3.515a3.5 3.5 0 0 1-3.412-4.287l2.435-10.55A1.5 1.5 0 0 1 4 6.5h3V4a2.5 2.5 0 0 1 2.5-2.5h5ZM3.027 18.888a.5.5 0 0 0 .488.612h16.971a.5.5 0 0 0 .488-.612L18.806 9.5H5.194l-2.166 9.388ZM10 6.5h4v-2h-4v2Z", fill: "currentColor" }));
  return iconset[size];
};
NavigationShoppingAfterpayIcon.iconId = "Xmin13";
